import React from 'react';
import AppRoutes from './routes';
import './assets/css/Style.css';

function App() {
  return (
    <AppRoutes></AppRoutes>
  );
}

export default App;
